
import ReactDOM from 'react-dom/client';
import App from './App';
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme"
import "./index.css"
import { registerChartExtensions } from './utils/chart/registerChartExtensions';

const root = ReactDOM.createRoot(document.getElementById('root'));

registerChartExtensions();

root.render(    
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
        </ThemeProvider>    
);

